export class UserGroup {
	userGroupId: number;
	newUserGroupId?: number;
	previousGroupId?: number;
	name: string = null;
	isDefaultGroup: boolean;
	isDefaultUserForGroup: boolean;
	isDefaultUserForGroupPrevious: boolean;
}
